import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RedditRoutingModule } from './reddit-routing.module';
import { RedditSubmissionDetailsComponent } from './Components/reddit-post-details/reddit-submission-details.component';
import { RedditService } from './Services/reddit.service';
import { RedditCommentsComponent } from './Components/reddit-comments/reddit-comments.component';
import { RedditSubmissionsComponent } from './Components/reddit-submissions/reddit-submissions.component';



@NgModule({
  declarations: [
    RedditSubmissionsComponent,
    RedditSubmissionDetailsComponent,
    RedditCommentsComponent,
  ],
  providers: [
    RedditService,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    RedditRoutingModule,
    FontAwesomeModule,
  ]
})
export class RedditModule { }